import type MP4Box from 'mp4box';
import { TrackEventProp } from '@studio/constants/tracking-constants';
import type { AddError, VideoUploadTrackEventProperties } from '../../types/upload-video';
import { VALIDATIONS } from '../../types/upload-video';

const validateFps = (
  info: MP4Box.Mp4BoxInfo,
  addError: AddError,
  trackEventProperties: VideoUploadTrackEventProperties
): string => {
  const supportedFramerates = [24, 25, 30, 50, 60];

  const [videoTrack] = info.videoTracks;
  const { nb_samples: nbSamples, samples_duration: totalSamplesDuration, timescale } = videoTrack;
  const sampleDuration = totalSamplesDuration / nbSamples;

  const fps = timescale / sampleDuration;

  if (fps - Math.floor(fps) === 0) {
    // Integer framerate must be exactly equal to a supported framerate

    console.log(`Supported integer frame rates: ${supportedFramerates} -- Actual FPS: ${fps}`);

    trackEventProperties[TrackEventProp.VIDEO_UPLOAD_FRAMERATE] = fps;

    if (supportedFramerates.includes(fps)) {
      return `${fps * 1000}/1000`;
    }
  } else {
    // Non-integer framerate requirements:
    // 1. sampleDuration is an integer multiple, N, of 1001
    // 2. timescale is an integer multiple, M, of a supported framerate * 1000
    // 3. N == M

    const sampleDurationMultiple = sampleDuration / 1001;
    console.log(
      `Supported Non-Integer frame rates: 24000/1001, 30000/1001, 60000/1001 -- Actual FPS: ${
        timescale / sampleDurationMultiple
      }/1001`
    );

    if (sampleDuration % 1001 === 0 && supportedFramerates.includes(timescale / sampleDurationMultiple / 1000)) {
      return `${timescale / sampleDurationMultiple}/${sampleDuration / sampleDurationMultiple}`;
    }
  }

  addError(VALIDATIONS.INVALID_FPS);
  return '';
};

export default validateFps;
